import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
import { closingLines, productShortName } from '../data/offer';
export function ClosingSection() {
  return <section className="bg-emerald-900 py-16 sm:py-20" aria-labelledby="closing-title" data-id="element-54" data-mp="12t3stjme3hm5">
      <div className="mx-auto max-w-4xl px-4" data-id="element-55" data-mp="xt91xg2m6s13">
        <div className="text-center" data-id="element-56" data-mp="xsfqw2wmhgd5">
          <h2 id="closing-title" className="text-balance text-3xl font-extrabold leading-tight text-stone-50 sm:text-4xl" data-id="element-57" data-mp="1cqrnyanwqr4u">
            El próximo lunes puedes seguir improvisando...
          </h2>
          <p className="mt-4 font-serif text-2xl font-extrabold tracking-tight text-amber-400 sm:text-3xl" data-id="element-58" data-mp="1ljbnrefxr1r9">
            O puedes entrar al aula con todo listo desde hoy.
          </p>
        </div>

        <ul className="mx-auto mt-10 grid max-w-3xl gap-3" data-id="element-59" data-mp="1vhiuz5kfa5g2">
          {closingLines.map((line, index) => <motion.li key={line} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.04,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-center gap-3 rounded-lg border-l-4 border-amber-500 bg-emerald-950 px-4 py-3 text-sm font-semibold text-stone-50" data-id="element-60" data-mp="1qio9fvv2m2s9" data-mpi={index}>
              <ChevronRightIcon className="h-4 w-4 shrink-0 text-amber-400" aria-hidden="true" data-id="element-61" data-mp="2gdoo32w3t6p0" />
              {line}
            </motion.li>)}
        </ul>

        <div className="mx-auto mt-10 max-w-2xl text-center" data-id="element-62" data-mp="2q9rs6eainfel">
          <p className="leading-relaxed text-emerald-100" data-id="element-63" data-mp="2q7yfoid820yo">
            El {productShortName} no te convierte en mejor docente. Vos ya eres un buen docente.
          </p>
          <p className="mt-3 text-lg font-bold text-stone-50" data-id="element-64" data-mp="2zzl0n6fd3eem">
            Lo que hace el megapack es darte el tiempo y las herramientas para que eso se note en cada clase.
          </p>
        </div>
      </div>
    </section>;
}